import React from 'react';

const EthiopiaFlag = ({ className = "w-4 h-3" }) => (
  <svg 
    viewBox="0 0 6 3" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="6" height="1" fill="#006233" y="0" />
    <rect width="6" height="1" fill="#FEDD00" y="1" />
    <rect width="6" height="1" fill="#EF3340" y="2" />
    <circle cx="3" cy="1.5" r="0.6" fill="#0039A6" />
    <path 
      d="M3 1l.13.4.4.13-.4.13-.13.4-.13-.4-.4-.13.4-.13z" 
      fill="#FEDD00" 
      transform="translate(0, 0)"
    />
  </svg>
);

export default EthiopiaFlag;
